import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { useState } from "react";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";
import { openLinkInNewTab } from "../../../helpers/helperMethods";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
  const { jobDetails, crumps } = props;

  const classes = styles();

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {jobDetails.title ? (
        <>
          <Grid container className={classes.topSection}>
            <Grid
              item
              xs={12}
              container
              direction="column"
              spacing={2}
              className={classes.infoSection}
              style={{
                marginLeft: 0,
              }}
            >
              <Grid item className={classes.textInfo}>
                <Typography variant="h4" className={classes.texts}>
                  {jobDetails.title}
                </Typography>

                <Grid item className={classes.actions}>
                  <Grid container spacing={2} justify="flex-end">
                    <SingleItemMenu
                      horiz
                      background
                      menu={props.actions}
                      item={jobDetails}
                    />
                  </Grid>
                </Grid>

                <Tooltip title="Author" placement="right-end" arrow>
                  <Typography
                    variant="h6"
                    className={classes.name}
                    // onClick={() => goToPage(`/authors/${jobDetails.authorEmail}`)}
                  >
                    Author: {jobDetails.author?.name || jobDetails.author?.id}
                  </Typography>
                </Tooltip>
                <Typography variant="body1" className={classes.texts}>
                  Status: {jobDetails.status}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Created: {moment(jobDetails.createdAt).fromNow()}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Remaining time: {moment(jobDetails.deadline).fromNow()}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Deadline: {moment(jobDetails.deadline).format("ll")}
                </Typography>

                <Typography
                  variant="body1"
                  className={classes.name}
                  onClick={() => openLinkInNewTab(jobDetails.pdfUrl)}
                >
                  View pdf..
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container></Grid>
          </Grid>
        </>
      ) : (
        <NoContent title="Unable to find Job" />
      )}
    </div>
  );
};
